import React, { useEffect, useState } from 'react';
import { makeStyles } from "@mui/styles";
import { Box, Grid, Button } from '@mui/material';
import FlagstoneTheme from '../../../Config/flagstoneTheme';
import WorkstationTile from '../../Workstation/WorkstationTile';
import { useNavigate } from 'react-router-dom';
import { dataService } from '../../../Services/data/data.service'
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';

export const WorkstationOverviewPage = (props) => {
    const classes = useStyles();
    const [activeWorkstationIds, setActiveWorkstationIds] = useState([]);
    const [workstations, setWorkstations] = useState([]);

    const { t } = useTranslation();
    let navigate = useNavigate();

    useEffect(() => {
        dataService.getAllWorkstations().then(result => {
            if (result.ok) {
                var stations = result.data.Results;
                setWorkstations(stations.sort((a, b) => (a.Id - b.Id)));
                console.log(stations.sort((a, b) => (a.Id - b.Id)))
                let workstationIds = [];
                var i;
                if (!props.workstation.noSelectedWorkstation) {
                    if (props.workstation.activeWorkstations) {
                        for (i = 0; i < props.workstation.activeWorkstations.length; i++) {
                            workstationIds.push(props.workstation.activeWorkstations[i].Id);
                        }
                    }
                }
            }

        }).catch((error) => { toast.error(error, { position: "top-center" }) });
    }, [props.workstation.activeWorkstations, props.workstation.noSelectedWorkstation]);

    function activateWorkstation(workstationId) {
        var tempActiveWorkstationIds = JSON.parse(JSON.stringify(activeWorkstationIds));
        if (tempActiveWorkstationIds.some(x => x === workstationId)) {
            let tempActiveWorkstations = Object.assign([], tempActiveWorkstationIds);
            if (tempActiveWorkstations.some(x => x === workstationId)) {
                let index = tempActiveWorkstations.indexOf(tempActiveWorkstations.find(x => x === workstationId));
                tempActiveWorkstations.splice(index, 1);
                setActiveWorkstationIds(tempActiveWorkstations);
            } else {
                tempActiveWorkstations.push(workstationId);
                setActiveWorkstationIds(tempActiveWorkstations);
            }
        } else {
            let tempActiveWorkstations = Object.assign([], tempActiveWorkstationIds);
            tempActiveWorkstations.push(workstationId);
            setActiveWorkstationIds(tempActiveWorkstations);
        }
    }

    function showPlanning() {
        let min = 0;
        if (workstations.length > 0) {
            if (activeWorkstationIds.length === 0) {
                props.actions.setActiveWorkstations(workstations);
                min = workstations[0].Id;
                props.actions.setNoSelectedWorkstation(true);
            } else {
                let activeWorkstations = workstations.filter(x => activeWorkstationIds.some(y => y === x.Id));
                props.actions.setActiveWorkstations(activeWorkstations);
                min = Math.min(...activeWorkstationIds);
                props.actions.setNoSelectedWorkstation(false);
            }

            props.actions.setSelectedWorkstation(min);
            navigate("/workstation");
        }
    }


    return (
        <Box className={classes.background}>
            <Box className={classes.spacer80}>
                {t("Checkpoints")}
            </Box>

            <Box p={3}>
                <Grid container justifyContent="center" spacing={2} className={classes.gridContainer}>
                    {workstations ?
                        workstations.map((workstation) => (
                            <Grid className={classes.gridmargin} key={workstation.Id} item>
                                <WorkstationTile {...props} activeWorkstationIds={activeWorkstationIds} maximumSelected={false} workstation={workstation} selectedWorkstation={null} activateWorkstation={activateWorkstation} active={activeWorkstationIds.some(x => x === workstation.Id)}></WorkstationTile>
                            </Grid>
                        )) : <React.Fragment></React.Fragment>}
                </Grid>
            </Box>

            <Box p={3}>
                <Grid container justifyContent="center" className={classes.buttonContainer}>
                    <Button className={classes.startProductionButton}
                        onClick={showPlanning}>{t("SHOW PLANNING")}</Button>
                </Grid>
            </Box>
        </Box>
    )
}

const useStyles = makeStyles({
    spacer80: {
        color: "#000000",
        fontSize: "32px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        paddingLeft: "20px"
    },
    gridmargin: {

    },
    gridContainer: {
        width: '100%',
        marginRight: "0px !important",
        marginLeft: "0px !important"
    },
    navButton: {
        textDecoration: 'none'
    },
    background: {
        width: '100%',
        position: "relative",
        top: "20px",
    },
    startProductionButton: {
        backgroundColor: FlagstoneTheme.palette.primary.main + " !important",
        width: "200px",
        height: "40px",
        marginLeft: "16px !important",
        color: "white !important",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        "&:hover": {
            background: FlagstoneTheme.palette.primary.main + " !important"
        },
    },
    buttonContainer: {
        textAlign: "center",
    },
});

function mapStateToProps(state) {
    return {
        workstation: state.workstation,
        general: state.general,
        user: state.user
    }
}

export default connect(mapStateToProps)(WorkstationOverviewPage)